export const LOCATION_CHECK_TARIFF_NAME = 'Тест Band';

export const isLocationCheckTariffName = (name) => {
  if (!name) return false;
  const value = String(name).trim();
  return value === LOCATION_CHECK_TARIFF_NAME || value.startsWith(`${LOCATION_CHECK_TARIFF_NAME}_`);
};

export const isLocationCheckProxy = (proxy) => {
  if (!proxy) return false;
  const orig = proxy._original || proxy;
  return (
    isLocationCheckTariffName(orig.tariff_plan_name)
    || isLocationCheckTariffName(orig.tariff_name)
    || isLocationCheckTariffName(orig.flexible_tariff_name)
    || isLocationCheckTariffName(orig.tariff_plan)
  );
};
